import { getTransResultDataFromDocBase } from '../docBase/docBase.utils';

// 导出模型工具
export const modelUtils = {
  getTransResultDataFromDocBase,
};
